import AbstractController from '@/Controller/AbstractController';
import "@/vendor/rater.jquery.js";

export default class Reviews extends AbstractController {
    constructor() {
        super();

        this.photos = [];
        this.photoTemplate = document.querySelector('#reviewFormPhotoTemplate').content.children[0];
        this.photosNode = document.querySelector('.review-form__previews');
        this.formNode = document.querySelector('.review-form form');
        this.submitButton = document.querySelector('.review-form__submit');

        $('.form-rating').rate({
            max_value: 5,
            step_size: 1,
            cursor: 'pointer'
        });

        $(".form-rating").on("change", (e, data) =>{
            $('.js-rating-input').val(data.to);
        });

        document.querySelector('.review-form__pick-file-input').addEventListener('change', this.onFilesPick.bind(this));
        document.querySelector('.review-form form').addEventListener('submit', this.onSubmit.bind(this));
    }

    onFilesPick(e) {
        if (e.target.files.length === 0) {
            return;
        }

        let hasErrors = false;
        let count = this.photos.filter(item => !!item).length;

        for (let file of e.target.files) {
            if (file.type !== 'image/jpeg' || count >= 3) {
                hasErrors = true;
                continue;
            }

            count++;

            this.photos.push({
                index: this.photos.length,
                file: file,
            });

            this.renderPreview(this.photos[this.photos.length - 1]);
        }

        if (hasErrors) {
            alert('Некоторые фото были пропущены, так как не являются форматом JPEG или превышено общее количество фото (3)');
        }

        e.target.value = null;
    }

    renderPreview(photo) {
        let el = this.photoTemplate.cloneNode(true);
        el.dataset.index = photo.index;

        let fileInput = el.querySelector('[name="file"]');
        fileInput.setAttribute('name', `photo[${photo.index}]`);

        el.querySelector('.review-form-photo__delete').addEventListener('click', this.onDeletePhotoClick.bind(this));

        this.photosNode.append(el);
        el = this.photosNode.querySelector(`.review-form-photo[data-index="${photo.index}"]`);

        if (photo.file) {
            let reader = new FileReader();
            reader.readAsDataURL(photo.file);

            reader.onload = (e) => {
                el.querySelector('.review-form-photo__image').setAttribute('src', e.target.result);
            };

            // Add the file to hidden input[type=file]
            let dataTransfer = new DataTransfer();
            dataTransfer.items.add(photo.file);
            fileInput.files = dataTransfer.files;
        } else {
            el.querySelector('.review-form-photo__image').setAttribute('src', photo.src);

            let link = el.querySelector('.review-form-photo__link');
            link.setAttribute('href', photo.src);
        }
    }

    onDeletePhotoClick(e) {
        e.preventDefault();

        const el = e.currentTarget.closest('.review-form-photo');
        const index = el.dataset.index;

        // Remove node
        el.remove();
        delete this.photos[index];
    }

    async onSubmit(e) {
        e.preventDefault();

        if (this.submitButton.disabled) {
            return;
        }

        if (!this.validate()) {
            return;
        }

        const formData = new FormData(e.currentTarget);

        let protect = e.currentTarget.dataset.protect;
        protect = protect.slice(-4) + protect.slice(0, -4);
        formData.append('_protect', protect);

        const urlParams = new URLSearchParams({
            c: 'nav:form',
            mode: 'class',
            action: 'submit',
            sessid: BX.message('bitrix_sessid'),
        });

        this.submitButton.disabled = true;
        this.submitButton.classList.add('review-form__submit--disabled');

        let response;

        try {
            response = await (await fetch(`/bitrix/services/main/ajax.php?${urlParams.toString()}`, {
                method: 'POST',
                body: formData,
            })).json();
        } catch (ex) {
            console.error(ex);
            alert(ex);
            return;
        } finally {
            this.submitButton.disabled = false;
            this.submitButton.classList.remove('review-form__submit--disabled');
        }

        if (response.status === 'error') {
            alert(response.errors.map(error => error.message).join("\n"));
            return;
        }

        $(this.formNode).fadeOut("normal", () => {
            let el = document.querySelector('.review-form__success');
            el.classList.remove('hidden');

            window.scrollTo({
                top: el.getBoundingClientRect().top + window.pageYOffset - 120,
                behavior: 'smooth',
            });
        });
    }

    validate() {
        let isValid = true;

        for (let code of ['name', 'email', 'orderNumber']) {
            let el = this.formNode.querySelector(`input[name="${code}"]`);

            if (!el.value) {
                el.classList.add('review-form__input--error');
                isValid = false;
            } else {
                el.classList.remove('review-form__input--error');
            }
        }

        let el = this.formNode.querySelector(`textarea[name="text"]`);

        if (!el.value) {
            el.classList.add('review-form__textarea--error');
            isValid = false;
        } else {
            el.classList.remove('review-form__textarea--error');
        }

        return isValid;
    }
}